import { Editor, useEditorState } from '@tiptap/react'
import { Button, Flex, Tooltip } from 'antd'
import { TextalignCenter, TextalignLeft, TextalignRight } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const MenuTextAlignmentButtons = ({ editor }: Props) => {
  const { t } = useTranslation()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isAlignLeft: ctx.editor.isActive({ textAlign: 'left' }) ?? false,
        isAlignCenter: ctx.editor.isActive({ textAlign: 'center' }) ?? false,
        isAlignRight: ctx.editor.isActive({ textAlign: 'right' }) ?? false,
        isAlignJustify: ctx.editor.isActive({ textAlign: 'justify' }) ?? false
      }
    }
  })

  return (
    <Flex gap="8px">
      <Tooltip title={t('editor.align_left')}>
        <Button
          onClick={() => editor.chain().focus().setTextAlign('left').run()}
          type={editorState.isAlignLeft ? 'primary' : 'default'}
          icon={<TextalignLeft size={14} />}
        />
      </Tooltip>

      <Tooltip title={t('editor.align_center')}>
        <Button
          onClick={() => editor.chain().focus().setTextAlign('center').run()}
          type={editorState.isAlignCenter ? 'primary' : 'default'}
          icon={<TextalignCenter size={14} />}
        />
      </Tooltip>

      <Tooltip title={t('editor.align_right')}>
        <Button
          onClick={() => editor.chain().focus().setTextAlign('right').run()}
          type={editorState.isAlignRight ? 'primary' : 'default'}
          icon={<TextalignRight size={14} />}
        />
      </Tooltip>
    </Flex>
  )
}
